var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuardSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#F4FAF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.998 19C25.99 19 24.04 21.019 21.734 21.755C20.796 22.055 20.327 22.204 20.137 22.415C19.947 22.625 19.892 22.934 19.781 23.55C18.591 30.146 21.191 36.244 27.391 38.618C28.056 38.873 28.389 39 29.001 39C29.613 39 29.947 38.872 30.613 38.617C36.812 36.244 39.409 30.146 38.219 23.55C38.108 22.934 38.052 22.625 37.862 22.414C37.672 22.203 37.204 22.054 36.266 21.755C33.959 21.019 32.006 19 28.998 19Z",
    stroke: "#4A3AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2501 26.959C27.2501 26.899 27.2581 26.553 27.2601 26.119C27.2601 25.721 27.2261 25.339 27.4161 24.989C28.1261 23.575 30.1661 23.719 30.6701 25.159C30.7571 25.396 30.7631 25.771 30.7601 26.119C30.7571 26.562 30.7661 26.959 30.7661 26.959M27.3371 27.38C26.2571 27.38 25.7171 28.16 25.5971 28.64C25.4771 29.12 25.4771 30.86 25.5491 31.58C25.7891 32.48 26.3891 32.852 26.9771 32.972C27.5171 33.02 29.7971 33.002 30.4571 33.002C31.4171 33.02 32.1371 32.66 32.4371 31.58C32.4971 31.22 32.5571 29.24 32.4071 28.64C32.0891 27.68 31.2971 27.38 30.6971 27.38H27.3371Z",
    stroke: "#4A3AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardSecurity);
export default __webpack_public_path__ + "static/media/guardSecurity.306bc6b7a4262892e0b14c76b3f5ed92.svg";
export { ForwardRef as ReactComponent };